export enum ApiVersion {
  OldTrivia = 1535, // from before recommendations were added
  WebStandard = parseInt(process.env.DOPPLER_PUBLIC_X_HALLOW_VERSION),
  TriviaRoutines = 2000,
  TheWordRoutines = 2040,
}
